import { FadeUp } from "@/components/Reveal";
import { SectionTitle } from "@/components/SectionTitle";

export const ProjectDetails = ({ details }) => (
  <section className="bg-ivory-muted py-20 lg:py-24" data-testid="project-details">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10">
      <FadeUp>
        <SectionTitle eyebrow={details.eyebrow ?? "The Proposal"} title={details.heading ?? "What the Resort Will Offer"}>
          {details.concept}
        </SectionTitle>
      </FadeUp>
      {details.stats && (
      <div className="mx-auto mt-12 grid max-w-5xl grid-cols-2 border-y border-gold/40 text-center md:grid-cols-4">
        {details.stats.map(([n, l]) => (
          <FadeUp key={l} className="px-2 py-6" data-testid={`project-stat-${n}`}>
            <p className="font-display text-5xl text-heritage md:text-6xl">{n}</p>
            <p className="mt-1 font-caps text-[11px] tracking-[0.2em] uppercase text-gold-deep">{l}</p>
          </FadeUp>
        ))}
      </div>
      )}
      <div className={`mt-14 grid gap-px bg-gold/30 sm:grid-cols-2 ${details.features.length === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
        {details.features.map((f, i) => (
          <FadeUp key={f.title} delay={(i % 3) * 0.06} className="bg-ivory-muted">
            <article data-testid={`project-feature-${i}`}>
              {f.image && (
                <div className="group overflow-hidden">
                  <img src={f.image} alt={f.title} loading="lazy" className="aspect-[2/1] w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.05]" />
                </div>
              )}
              <div className="p-7 md:p-9">
              <p className="font-caps text-sm text-gold-deep">{String(i + 1).padStart(2, "0")}</p>
              <h3 className="mt-3 font-caps text-xl leading-snug text-heritage">{f.title}</h3>
              <p className="mt-3 text-[17px] leading-relaxed text-muted-ink">{f.text}</p>
              </div>
            </article>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
